import { render, staticRenderFns } from "./RightNav.v2.vue?vue&type=template&id=6aa181b3&scoped=true"
import script from "./RightNav.v2.vue?vue&type=script&lang=js"
export * from "./RightNav.v2.vue?vue&type=script&lang=js"
import style0 from "./RightNav.v2.vue?vue&type=style&index=0&id=6aa181b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa181b3",
  null
  
)

export default component.exports